import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const StatusTitle = styled.header`
  position: relative;
  width: 125px;
  display: inline-block;
  padding-left: 55px;
  margin-bottom: 10px;
  box-sizing: border-box;

  color: ${getToken('color-neutral-darker')};
  font-weight: bold;
  font-size: 14px;
  vertical-align: top;

  ${screen.md} {
    margin-bottom: 0;
  }

  &:before {
    position: absolute;
    left: 20px;
    z-index: 2;

    display: inline-block;
    width: 14px;
    height: 14px;

    background-color: ${getToken('color-neutral-light')};
    border: 2px solid ${getToken('color-neutral-light')};
    border-radius: 50%;

    content: '';
  }

  .is-previous &,
  .is-current & {
    &:before {
      background-color: ${getToken('color-primary')};
      border: 2px solid ${getToken('color-primary')};
    }
  }

  &.is-nolabel {
    &:before,
    &:after {
      display: none;
    }
  }

  &.is-large {
    font-size: 16px;
  }
`
